// React
import React, { useState } from 'react';

// Styles
import styles from './ColumnsSelector.module.scss';

// Third party
import PropTypes from 'prop-types';

// Material UI
import {
  ButtonGroup,
  Button,
  Popover,
  ClickAwayListener,
  List,
  ListItem,
  FormControlLabel,
  FormControl,
  FormGroup,
  Checkbox
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

// This component
export default function ColumnsSelector({ columns, setColumns }) {
  // All columns are visible
  const [allColumns, setAllColumns] = useState(
    columns.filter((column) => !column.hideFromColumnsSelector && column.hide)
      .length === 0
  );

  // Handle all columns button click
  const handleAllColumnsClick = (event) => {
    let copy = [...columns];

    copy.forEach((column, i) => {
      if (!column.hideFromColumnsSelector) {
        copy[i].hide = false;
      }
    });

    setColumns(copy);
    setAllColumns(
      copy.filter((column) => !column.hideFromColumnsSelector && column.hide)
        .length === 0
    );
  };

  // Dropdown anchor
  const [dropdown, setDropdown] = useState(null);

  // Visible or not (status)
  const open = Boolean(dropdown);

  // Handle dropdown click
  const handleDropdownClick = (event) => {
    setDropdown(event.currentTarget);
  };

  // Handle dropdown close
  const handleDropdownClose = () => {
    setDropdown(null);
  };

  // Handle checkbox change
  const handleCheckboxChange = (event) => {
    const id = event.currentTarget.name;
    let copy = [...columns];

    copy.forEach((column, i) => {
      if (column.field === id) {
        copy[i].hide = !column.hide;
      }
    });

    setColumns(copy);
    setAllColumns(
      copy.filter((column) => !column.hideFromColumnsSelector && column.hide)
        .length === 0
    );
  };

  // JSX
  return (
    <div className={styles.wrapper}>
      <ButtonGroup size="small" disableElevation={true} color="secondary">
        <Button
          variant={allColumns ? 'contained' : 'outlined'}
          onClick={handleAllColumnsClick}>
          All Columns
        </Button>

        <Button
          variant={allColumns ? 'outlined' : 'contained'}
          onClick={handleDropdownClick}
          endIcon={<KeyboardArrowDownIcon fontSize="small" />}>
          Select Columns
        </Button>
      </ButtonGroup>

      <Popover
        classes={{ paper: styles.paper }}
        elevation={1}
        open={open}
        anchorEl={dropdown}
        onClose={handleDropdownClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}>
        <ClickAwayListener onClickAway={handleDropdownClose}>
          <List className={styles.list}>
            <ListItem className={styles.item}>
              <FormControl component="fieldset">
                <FormGroup>
                  {columns &&
                    columns
                      .filter((column) => !column.hideFromColumnsSelector)
                      .map((column, i) => {
                        return (
                          <FormControlLabel
                            key={i}
                            label={column.headerName}
                            control={
                              <Checkbox
                                name={column.field}
                                size="small"
                                checked={!column.hide}
                                onChange={handleCheckboxChange}
                              />
                            }
                          />
                        );
                      })}
                </FormGroup>
              </FormControl>
            </ListItem>
          </List>
        </ClickAwayListener>
      </Popover>
    </div>
  );
}

// Properties
ColumnsSelector.propTypes = {
  columns: PropTypes.array.isRequired,
  setColumns: PropTypes.func.isRequired
};
